import React, { useState } from "react";
import "./SupportDashboard.css";

export default function SupportDashboard() {
  const statusCards = [
    { label: "Open", count: 0 },
    { label: "In Progress", count: 0 },
    { label: "On Hold", count: 0 },
    { label: "Pending Customer Response", count: 0 },
    { label: "Escalated", count: 0 },
    { label: "Closed", count: 0 },
    { label: "Reopened", count: 0 },
    { label: "Canceled", count: 0 },
    { label: "Duplicate", count: 0 },
    { label: "Awaiting Approval", count: 0 },
    { label: "In Review", count: 0 },
    { label: "Scheduled", count: 0 },
  ];

  const messages = [
    // {
    //   subject: "Approval Withdrawal",
    //   desc: "Please approve withdrawal...",
    //   date: "Tuesday, April 15, 2025",
    // },
    // {
    //   subject: "Deposit Approval",
    //   desc: "Please approve my deposit...",
    //   date: "Monday, April 14, 2025",
    // },
  ];

  const labels = ["Low", "Medium", "High", "Urgent", "Emergency", "Critical"];

  // ✅ State for collapsible sections
  const [statusOpen, setStatusOpen] = useState(false);
  const [labelsOpen, setLabelsOpen] = useState(false);

  return (
    <div className="support-dashboard">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <span>Home</span> / <span>Support Dashboard</span>
      </div>

      {/* Title */}
      <h2 className="page-title">Support Dashboard</h2>

      {/* Top Status Cards */}
      <div className="status-cards">
        {statusCards.map((item, index) => (
          <div key={index} className="status-card">
            <div className="count">{item.count}</div>
            <div className="label">{item.label}</div>
          </div>
        ))}
      </div>

      {/* Main Layout */}
      <div className="main-layout">
        {/* Left Sidebar */}
        <div className="left-panel">
          <button className="btn-compose">Compose</button>

          {/* Status Section */}
          <div className="section">
            <div
              className="section-header"
              onClick={() => setStatusOpen(!statusOpen)}
            >
              Status
              <span className="toggle-icon">{statusOpen ? "−" : "+"}</span>
            </div>
            {statusOpen && (
              <ul className="section-list">
                {statusCards.map((s, i) => (
                  <li key={i}>
                    <span className="icon">📂</span> {s.label}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Labels Section */}
          <div className="section">
            <div
              className="section-header"
              onClick={() => setLabelsOpen(!labelsOpen)}
            >
              Labels
              <span className="toggle-icon">{labelsOpen ? "−" : "+"}</span>
            </div>
            {labelsOpen && (
              <ul className="section-list">
                {labels.map((l, i) => (
                  <li key={i}>
                    <span className="icon">🏷️</span> {l}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* Inbox Section */}
        <div className="right-panel">
          <div className="inbox-header">
            <span>Inbox</span>
            <div className="search-box">
              <input type="text" placeholder="Search Mail" />
              <button>🔍</button>
            </div>
          </div>

          <div className="inbox-list">
            {messages.map((msg, i) => (
              <div key={i} className="inbox-item">
                <div className="subject">{msg.subject}</div>
                <div className="desc">{msg.desc}</div>
                <div className="date">{msg.date}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

